// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"1b93216d","151":"dc4b6ae2","585":"e84ce31d","851":"78d6dd5c"}[chunkId] + ".chunk.js";
};